import VueRouter, { RouteConfig } from 'vue-router'
const NoticeCenter = () => import('../views/NoticeCenter.vue')

export const noticeCenterRoute: RouteConfig = {
  path: '/notice-center',
  name: 'notice_center',
  component: NoticeCenter,
  meta: { title: '消息中心' },
  props: (route) => ({ category: route.query.category, title: route.query.title }),
}

export default [noticeCenterRoute]

export function navToNoticeCenter(router: VueRouter) {
  router.push({ name: noticeCenterRoute.name })
}
